
import axios from "axios";
import { Component, Vue } from "vue-property-decorator";

@Component
export default class StatusComponent extends Vue {
  private message: string | undefined = "";
  // SUCCESS = 1, ERROR = 2, WARNING = 3, NOTICE = 4
  private status = 0;

  async mounted() {
    if (
      Object.prototype.hasOwnProperty.call(
        Vue.router.currentRoute.query,
        "status"
      )
    ) {
      this.status = Number(Vue.router.currentRoute.query.status);
      if (
        Object.prototype.hasOwnProperty.call(
          Vue.router.currentRoute.query,
          "status_message"
        )
      ) {
        this.message = Vue.router.currentRoute.query.status_message as string;
      }
    } else {
      this.status = 0;
      this.message = "";
    }
  }

  public success(message: string): void {
    this.status = 1;
    this.message = message;
    this.scrollToView();
  }

  public warning(message: string): void {
    this.status = 3;
    this.message = message;
    this.scrollToView();
  }

  public error(message: any): void {
    this.status = 2;
    this.message = message;
    this.scrollToView();
  }

  public scrollToView(): void {
    if (this.$refs["status-component"]) {
      const $el = this.$refs["status-component"] as Element;
      $el.scrollIntoView({ behavior: "smooth" });
    }
  }
  /**
   * Will analyze the error response formatted by axios.
   * @param error
   */
  public error_response(error: any): void {
    if (!error) {
      this.message = "Unknown error.";
      this.status = 2;
      return;
    }
    if (axios.isAxiosError(error) && error.response) {
      const data = error.response.data;
      this.message = error.response.data.message;
      if (data.parameters) {
        data.parameters.forEach((e, i) => {
          // eslint-disable-next-line no-console
          console.log("createUser", e, `%${i + 1}`, this.message);
          this.message = this.message?.replace(`%${i + 1}`, e);
        });

        // eslint-disable-next-line no-console
        console.log("createUser", error.response);
      }
    } else if (!error.response) {
      this.message = error;
    } else {
      this.message = "Unknown error.";
    }
    this.status = 2;
  }

  public clear() {
    this.status = 0;
    this.message = "";
  }
}
